import { useLayoutEffect, useSyncExternalStore } from 'react';

/** One boot splash for the whole startup. Each gate holds it; the overlay
 * stays mounted, so the animation does not restart between gates. */
let holders = 0;
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((listener) => listener());
}

export function useBootHold(active: boolean) {
  useLayoutEffect(() => {
    if (!active) return;
    holders += 1;
    emit();
    return () => {
      holders -= 1;
      emit();
    };
  }, [active]);
}

export function useBootVisible() {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => holders > 0,
  );
}
